<footer class="bg-white-dark px-14 py-2 flex flex-col md:flex-row items-center md:justify-between mt-2">
    <span class="text-primary text-sm font-bold">© {{ currentYear }} KnOot Academy</span>


<div class="block md:hidden w-[90%] border-t border-primary my-4"></div>

    <div class="flex flex-col md:flex-row items-center gap-2">
        <span><a class="text-sm" href="https://knoot-academy.de/" target="_blank">Die KnOot Academy</a></span>
        <span class="hidden md:block"> | </span>
        <span><a class="text-sm" href="https://knoot-academy.de/impressum" target="_blank">Impressum</a></span>
        <span class="hidden md:block"> | </span>
        <span><a class="text-sm" href="https://knoot-academy.de/datenschutz" target="_blank">Datenschutz</a></span>
        <span class="hidden md:block"> | </span>
        <span><a class="text-sm" href="https://knoot-academy.de/agb" target="_blank">AGB</a></span>
        <span class="hidden md:block"> | </span>
        <span><a class="text-sm" href="https://knoot-academy.de/kontakt" target="_blank">Kontakt</a></span>
    </div>
</footer>